const sortColorPickerColors = (colors, newColor, chartType = 'simpleChart') => {
  // Cópia do estado de cores memorizadas da paleta de cores do color picker
  const memorizedColors = [...colors];

  // Procura o index (posicao do array) do elemento do array de cores que tenha o mesmo valor da cor
  // selecionada
  const newColorIndex = memorizedColors.findIndex((tempArrItem) => tempArrItem === newColor);

  // array.prototype.splice(-1,1) remove a ultima posicao do array
  // array.protype.findIndex((item)=> condicao) retorna -1 caso nenhum item consiga sucesso na condicao
  // ou seja, se ele nao encontrar nenhuma cor no array de cores memorizadas que seja igual a nova cor,
  // ele vai remover a ultima posicao do array, caso contrario, remove a posicao da cor selecionada
  memorizedColors.splice(newColorIndex, 1);
  // Aqui ele adiciona o elemento newColor ao array na posicao 0
  memorizedColors.splice(0, 0, newColor);
  localStorage.setItem(`@analyze/${chartType}/color-picker-memorized-colors`, JSON.stringify(memorizedColors));
  return memorizedColors;
};
export default sortColorPickerColors;
